module.exports = {"ILLICADO":{"component":"EmbeddedCardForm"}}